// Imports
import { StripeError } from '@stripe/stripe-js';
import * as Sentry from '@sentry/browser';


/** Reports an unexpected Stripe error to Sentry as a real `Error` with details attached as extra context */
export default function reportStripeError(error: StripeError): void {
	Sentry.captureException(new Error(error.message ?? 'Unknown Stripe error'), {
		extra: {
			type: error.type,
			code: error.code,
			docURL: error.doc_url,
			paymentIntentID: error.payment_intent?.id,
		},
	});
}
